<template>
<div class="h-100">
    <div class="box-page">
        <div class="page-header">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">รายการถอน</span>
                <div id="wgCalendar" class="wgCalendar-normal ml-2" data-initLabelText="ทั้งหมด"></div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-search2">
                        <i class="fa fa-search"></i>
                        <input type="text" name="search" placeholder="ค้นหาชื่อและเบอร์โทร" v-model="keyword" @keypress.enter="loadList()" class="ele-search2-input">
                    </div>
                </div>
            </div>
        </div>
        <div class="page-content">
            <div class="w-100" style="overflow-x: auto;">
                <table id="tb_datalist" class="table table-hover">
                    <thead>
                        <tr>
                            <th style="width:170px;min-width: 170px">
                            </th>
                            <th style="width:70px;">
                                <div class="text-btn header-text text-center">
                                    <span>ลำดับ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>วันที่ทำรายการ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text text-center">
                                    <span>สถานะ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>ชื่อ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>เบอร์โทร</span>
                                </div>
                            </th>
                            <th style="width: 180px;">
                                <div class="text-btn header-text text-right">
                                    <span>ยอดเงิน</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>ธนาคาร</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>เลขบัญชี</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>ผู้อนุมัติ</span>
                                </div>
                            </th>
                            <th style="width: 160px;">
                                <div class="text-btn header-text">
                                    <span>วันที่อนุมัติ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>หมายเหตุ</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in listDeposit" :key="idx">
                            <td class="align-middle text-center">
                                <div class="show-on-hover" v-if="!item.is_completed && !item.is_cancel">
                                    <div class="btn-group">
                                        <button class="btn btn-table" @click="confirmWithdraw(item)">ยืนยันการถอน</button>
                                    </div>
                                    <div class="btn-group">
                                        <a data-toggle="dropdown" href="">
                                            <img height="24" :src="'../../goobank_assets/common/img/icons/threedots.png'" />
                                        </a>
                                        <div class="dropdown-menu">
                                            <a href="#" class="dropdown-item" @click="cancelWithdraw(item.id)">ยกเลิกรายการ</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span v-text="getRowNo(idx + 1)"></span>
                            </td>
                            <td>
                                <span v-text="item.created_at_text"></span>
                            </td>
                            <td class="text-center">
                                <span class="tag-staff" :class="item.status_css" v-text="item.status_text"></span>
                            </td>
                            <td>
                                <span v-text="item.member_name"></span>
                            </td>
                            <td>
                                <span v-text="item.member_phone"></span>
                            </td>
                            <td class="text-right">
                                <span v-text="item.amount"></span>
                            </td>
                            <td>
                                <span v-text="item.bank_name"></span>
                            </td>
                            <td>
                                <span v-text="item.bank_account"></span>
                            </td>
                            <td>
                                <span v-text="item.approver_name"></span>
                            </td>
                            <td>
                                <span v-text="item.approve_at_text"></span>
                            </td>
                            <td>
                                <span v-text="item.withdraw_note"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <PaginationComponent :lastPage="lastPage" :currentPage="currentPage" ref="pagination"
                @prevPage="prevPage_Click()" @nextPage="nextPage_Click()" @changePage="changePage_Click($event)"></PaginationComponent>
            </div>
        </div>
    </div>

    <div class="modal-group">
        <div id="modal_confirm" class="modal fade">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <div class="d-flex w-100 justify-content-between">
                            <div>
                                <h4 class="modal-title">ยืนยันการถอน</h4>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="icon-close"></i>
                            </span>
                        </button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="container">
                            <div class="with-underline text-center">
                                <div v-text="confirmValue.amount" class="amount-confirm mb-3"></div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-6">
                                    <span v-text="confirmValue.bankName || 'ธนาคาร'"></span>
                                </div>
                                <div class="col-md-6">
                                    <span>เลขบัญชี</span>
                                    <span v-text="confirmValue.bankAccount"></span>
                                </div>
                            </div>

                            <div class="row mt-4 d-none">
                                <div class="col-md-12">
                                    <div>สลิป</div>
                                    <div class="text-center">
                                        <img :src="confirmValue.imgSlip" class="img-slip mt-2" @click="openImg(confirmValue.imgSlip)">
                                        <input type="file" ref="fileSlipTransfer" @change="previewFiles($event, 'slipTransfer')" accept="image/x-png,image/jpeg" style="display:none;">
                                        <div class="mt-2"><button class="btn btn-small" @click="$refs.fileSlipTransfer.click()">อัพโหลดสลิป</button></div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4 mb-4">
                                <div class="col-md-12">
                                    <div class="with-underline text-center">
                                        หมายเหตุการถอน : <input id="withdraw_note" name="withdraw_note" type="text" value="" v-model="confirmValue.withdraw_note" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <div>
                            <button type="button" class="btn btn-small btn-dismiss" data-dismiss="modal">ยกเลิก</button>
                            <button type="button" class="btn btn-small btn-ok" data-dismiss="modal" @click="approveWithdraw">ตกลง</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal_cancel_withdraw_reason" class="modal fade">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <div class="d-flex w-100 justify-content-between">
                            <div>
                                <h4 class="modal-title">ยกเลิกการถอนเพราะ...</h4>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="icon-close"></i>
                            </span>
                        </button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="container">
                            <div class="mb-2">เลือกเหตุผลในการยกเลิก</div>
                            <select v-model="reason" class="form-control">
                                <option>เนื่องจากอยู่นอกเวลาการถอน</option>
                                <option>เนื่องจากระบบขัดข้องกรุณาแจ้งถอนใหม่อีกครั้งภายหลัง</option>
                            </select>
                        </div>
                    </div>

                    <input type="hidden" v-model="reason_id" />
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <div>
                            <button type="button" class="btn btn-small btn-dismiss" data-dismiss="modal">ยกเลิก</button>
                            <button type="button" class="btn btn-small btn-ok" data-dismiss="modal" @click="confirmCancelWithdraw">ยืนยันปฏิเสธการถอน</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import PaginationComponent from './../sub_components/PaginationComponent';
    import ImageSlipInit from '../../../assets/img/avatar.png';
    import ShareFunction from '../../share-function';

    export default {
        components: {
            PaginationComponent
        },
        data: function () {
            return {
                listDeposit: [],
                startDate: null,
                endDate: null,
                keyword: '',
                confirmValue: {
                    id: null,
                    amount: null,
                    bankName: null,
                    bankAccount: null,
                    imgSlip: '',
                    withdraw_note: ''
                },
                totalPage: 1,
                totalItems: 0,
                lastPage: 1,
                pageSize: 50,
                currentPage: 1,
                reason: '',
                reason_id: 0
            }
        },
        mounted() {
        },
        created() {
            this.confirmValue.imgSlip = ImageSlipInit;
            this.buildJquery();
            this.loadList();
            setInterval(() => {
                this.loadList();
            }, 5000);
        },
        computed: {
        },
        methods: {
            prevPage_Click() {
                this.currentPage -= 1;
                this.loadList();
            },
            nextPage_Click() {
                this.currentPage += 1;
                this.loadList();
            },
            changePage_Click(pageNo) {
                this.currentPage = pageNo;
                this.loadList();
            },
            loadList() {
                let params = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    keyword: this.keyword,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage
                };
                axios.post(`${this.baseUrl}/admin/api/list-withdraw`, params).then(({ data }) => {
                    if (data != null) {
                        const rows = Array.isArray(data.data) ? data.data : [];
                        if (rows.length > 0) {
                            rows.forEach(item => {
                                item.created_at_text = moment(item.created_at).format('DD/MM/YYYY HH:mm:ss');
                                if (item.approve_at) {
                                    item.approve_at_text = moment(item.approve_at).format('DD/MM/YYYY HH:mm:ss');
                                }
                                item.status_text = (item.is_completed ? 'ตรวจสอบแล้ว' : item.is_cancel ? 'ยกเลิก' : 'ยังไม่ได้ตรวจสอบ');
                                item.status_css = item.is_completed ? 'tag-complete' : 'tag-wait';
                            });
                        }
                        this.totalItems = (parseInt(data.total, 10) || 0);
                        this.lastPage = (parseInt(data.totalPage, 10) || 1);
                        this.listDeposit = rows;

                        this.$nextTick(() => {
                            if (this.$refs.pagination && typeof this.$refs.pagination.bindListPageNo === 'function') {
                                this.$refs.pagination.bindListPageNo();
                            }
                        });
                    }
                });
            },
            choosePage(currentPage) {
                this.currentPage = currentPage;
                this.loadList();
            },
            getRowNo(index) {
                return ((this.currentPage - 1) * this.pageSize) + index;
            },
            confirmWithdraw(tran) {
                this.confirmValue.id = tran.id;
                this.confirmValue.amount = tran.amount;
                this.confirmValue.bankName = tran.bank_name;
                this.confirmValue.bankAccount = tran.bank_account;
                this.confirmValue.imgSlip = ImageSlipInit;
                this.confirmValue.withdraw_note = "";
                this.$refs.fileSlipTransfer.value = null;
                $('#modal_confirm').modal('show');
            },
            cancelWithdraw(id) {
                this.reason_id = id;
                this.reason = '';
                $('#modal_cancel_withdraw_reason').modal('show');
            },
            confirmCancelWithdraw()
            {
                const vm = this;
                axios.post(`${this.baseUrl}/admin/api/cancel-withdraw`,{
                    id: vm.reason_id,
                    reason: vm.reason
                }).then(({ data }) => {
                    if (data != null && data.success) {
                        alertbox('บันทึกสำเร็จ');
                        this.loadList();
                    } else if (data != null && data.message) {
                        alertbox(data.message, 'warning');
                    }
                })
                .catch(err => {
                    console.log('err approve-withdraw : ', err)
                });
            },
            approveWithdraw() {
                axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content");
                const fileSlipTransfer = this.$refs.fileSlipTransfer;
                var formData = new FormData();
                formData.append('id', this.confirmValue.id);
                formData.append('fileSlip', fileSlipTransfer.files[0]);
                formData.append('withdrawNote', this.confirmValue.withdraw_note);

                console.log('fileSlipTransfer.files[0]', fileSlipTransfer.files[0]);
                axios.post(`${this.baseUrl}/admin/api/approve-withdraw`, formData)
                .then(({ data }) => {
                    if (data != null && data.success) {
                        alertbox('บันทึกสำเร็จ');
                        this.loadList();
                    } else if (data != null && data.message) {
                        alertbox(data.message, 'warning');
                    }
                })
                .catch(err => {
                    console.log('err approve-withdraw : ', err)
                });
            },
            buildJquery() {
                const vm = this;
                $(document).ready(function () {
                    $('#wgCalendar').wgCalendar({
                        startDate: new Date(),
                        submitDate: function(data, self) {
                            if (data.isAllDate) {
                                vm.startDate = null;
                                vm.endDate = null;
                            } else {
                                vm.startDate = moment(data.startDate).format('YYYY-MM-DD');
                                vm.endDate = moment(data.endDate).format('YYYY-MM-DD');
                            }
                            vm.loadList();
                        }
                    });
                });
            },
            previewFiles(ev, target) {
                var vm = this;
                var files = event.target.files;
                if (files && files[0]) {
                    if (files[0].type != 'image/png' && files[0].type != 'image/jpeg') {
                        window.alertbox('only jpg/jpeg file types are allowed', 'warning');
                        vm.resetAvatar(ev);
                        return;
                    }
                    var fileSize = files[0].size;
                    var mbMaxSize = 5 * (1024 * 1024);
                    if (fileSize > mbMaxSize) {
                        window.alertbox('Maximum allowed 5MB for uploaded files', 'warning');
                        vm.resetAvatar(ev);
                        return;
                    }
                    var reader = new FileReader();
                    vm.imageLoading = true;
                    reader.onload = function(e) {
                        vm.confirmValue.imgSlip = e.target.result;
                    }
                    reader.readAsDataURL(files[0]);
                }
            },
            openImg(src) {
                ShareFunction.openImg(src);
            }
        },
        props: {
            baseUrl: '',
        },
    }
</script>

<style lang="scss" scoped>
    .ele-search {
        margin-left: auto;
        margin-right: 0;
        width: 400px;
        max-width: 400px;
    }
    .img-logo-bank {
        width: 24px;
        height: 24px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .img-slip {
        max-width: 300px;
        max-height: 400px;
    }
    .tag-staff {
        &.tag-complete {
            padding: 2px 20px;
            background-color: #01df01;
        }
        &.tag-wait {
            background-color: #ff0000;
        }
    }
    .amount-confirm {
        display: inline-block;
        padding: 8px 16px;
        border: 1px solid;
        min-width: 350px;
        font-size: 32px;
        color: #495057;
    }
</style>




